'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCheckedSongsArray = exports.getFilteredSongs = exports.getAllSongs = undefined;

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _values = require('babel-runtime/core-js/object/values');

var _values2 = _interopRequireDefault(_values);

var _invertBy2 = require('lodash/invertBy');

var _invertBy3 = _interopRequireDefault(_invertBy2);

var _reselect = require('reselect');

var _utils = require('helpers/utils');

var _playlists = require('./playlists');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import {processTracks} from '../helpers/Playlists';
// import {asArray} from 'helpers/TypeCast';
var _getAlbumsTracks = function _getAlbumsTracks(state) {
  return state.songs.songsData.tracks;
}; /* Playlists and albums reselect */

var getCheckedSongs = function getCheckedSongs(state) {
  return state.songs.checkedSongs;
};
var getKw = function getKw(state) {
  return state.songs.kw;
};

var filteredFields = ['trackName', 'artist', 'isrc', 'albumArtist'];

var getAllSongs = exports.getAllSongs = (0, _reselect.createSelector)([_getAlbumsTracks, _playlists.getAllTracks], function (tracks, allTracks) {
  var tracksArr = [];
  (0, _values2.default)(allTracks).map(function (track) {
    tracksArr = [].concat((0, _toConsumableArray3.default)(tracksArr), [track]);
  });
  return tracksArr;
});

var getFilteredSongs = exports.getFilteredSongs = (0, _reselect.createSelector)([getAllSongs, getKw], function (songs, kw) {
  return (0, _utils.filterObjectsByKws)({ objects: songs, fields: filteredFields, kw: kw });
});

var getCheckedSongsArray = exports.getCheckedSongsArray = (0, _reselect.createSelector)([getCheckedSongs], function (songs) {
  return ((0, _invertBy3.default)(songs).true || []).map(Number);
});


//////////////////
// WEBPACK FOOTER
// ./src/selectors/songs.js
// module id = 875
// module chunks = 1